import {
  ref,
  reactive,
  onBeforeMount,
  getCurrentInstance,
  watch,
  computed,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import usePagination from "@/views/components/pagination/usePagination";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import surveyModel from "@/models/survey-quiz/survey";
import useDate from "@/utils/hooks/useDate";

import usePermissionByAccount from "@/constants/navigation/BOYNYKJMS2EH/permission-by-account"

export default function useSurveyList() {
  const { getPermissionModule } = usePermissionByAccount()

  const {
    fetchSurveyListModel,
    fetchSurveyDeleteModel,
    chagneStatusToggle,
  } = surveyModel();

  const { pagination, onPageChange, onFilterEntity } = usePagination();

  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable();

  const {
    openDefaultErrorModal,
    openWarningModal,
    openSuccessModal,
  } = useValidationModal();

  const { resolveDateWithSeperator, resolveTime } = useDate();

  const loading = reactive({
    tableData: false,
  });

  const optionData = reactive({
    suveyList: [],
  });

  const fields = [
    { key: "seq", label: "No." },
    { key: "cover_image_url", label: "Image" },
    { key: "title", label: "Tiltle Name" },
    { key: "created_by", label: "Create By" },
    { key: "valid_from", label: "Valid From" },
    { key: "valid_through", label: "Valid Through" },
    { key: "status", label: "Status" },
    { key: "actions", label: "" },
  ];

  const statusOption = ref([
    { label: "Active", value: 1 },
    { label: "Inactive", value: 2 },
  ]);

  const formStatus = reactive({
    status: null,
  });

  const surveyActionList = reactive({
    edit: {
      label: "Edit",
      value: 1,
      icon: "IconEdit",
      display: true,
    },
    delete: {
      label: "Delete",
      value: 2,
      icon: "IconTrash",
      display: true,
    },
  });

  const resolveMappingTableAction = (type, item) => {
    switch (type) {
      case 1:
        router.push(`/survey/info/${item.item.survey_groupid}`);
        return;
      case 2:
        deleteSurvey(item.item);
        return;
      default:
    }
  };

  const surveyListTable = reactive({
    payload: [],
  });

  const fetchSurveyList = (showLoading = true) => {
    if (showLoading) {
      loading.tableData = true;
    }
    fetchSurveyListModel.payload.Page = pagination.currentPage;
    fetchSurveyListModel.payload.Limit = pagination.perPage;
    fetchSurveyListModel.payload.Filters = filters;
    fetchSurveyListModel.payload.Ordering = ordering.value;
    store
      .dispatch("api/apiRequest", fetchSurveyListModel)
      .then((response) => {
        surveyListTable.payload = response.data.payload;
        pagination.rows = response.data.payload.length;
        pagination.totalRows = response.data.filtered_record;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  const deleteSurvey = (surveyGroup) => {
    openWarningModal(
      "ลบ Survey",
      `ต้องการลบ ${surveyGroup.title} ใช่หรือไม่`,
      () => {
        loading.tableData = true;
        fetchSurveyDeleteModel.payload.Survey_GroupId =
          surveyGroup.survey_groupid;
        store
          .dispatch("api/apiRequest", fetchSurveyDeleteModel)
          .then((response) => {
            fetchSurveyList();
          })
          .catch((error) => {
            loading.tableData = false;
            openErrorModal(error);
          })
          .finally(() => {});
      }
    );
  };

  const onToggleStatus = (status, surveyGroup) => {
    loading.tableData = true;
    chagneStatusToggle.payload.Survey_GroupId = surveyGroup.survey_groupid;
    chagneStatusToggle.payload.Status = status ? 1 : 2;
    store
      .dispatch("api/apiRequest", chagneStatusToggle)
      .then((response) => {
        fetchSurveyList();
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  const setDefaultActiveTab = () => {
    localStorage.removeItem("activeTab");
  };

  const onCreateSurvey = () => {
    setDefaultActiveTab();
    router.push("/survey/create");
  };

  const onOpenDashboard = (item) => {
    router.push({
      path: `/survey/dashborad/${item.survey_groupid}`,
    });
  };

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchSurveyList();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      fetchSurveyList();
    },
    { deep: true }
  );

  onBeforeMount(() => {
    fetchSurveyList();
  });

  return {
    loading,
    optionData,
    fields,
    statusOption,
    pagination,
    onPageChange,
    onFilterEntity,
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
    surveyListTable,
    resolveMappingTableAction,
    surveyActionList,
    onCreateSurvey,
    onToggleStatus,
    resolveDateWithSeperator,
    resolveTime,
    formStatus,
    onOpenDashboard,
    getPermissionModule
  };
}
